import { Button } from '@nolens/ui';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useRegisterSW } from 'virtual:pwa-register/react';

/** "Nova versão disponível" — nunca durante o player ou o check-in. */
export function UpdatePrompt() {
  const location = useLocation();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const busy = /\/(sessao|check-in)$/.test(location.pathname);
  if (!needRefresh || busy) return null;
  return (
    <div role="status" className="fixed inset-x-0 bottom-20 z-40 mx-auto flex w-[min(520px,calc(100vw-24px))] items-center gap-3 rounded-full bg-ink py-2 pl-5 pr-2 text-surface-0 shadow-xl md:bottom-6">
      <span className="flex-1 text-sm">Há uma nova versão da app.</span>
      <button type="button" className="px-2 text-sm text-surface-0/70" onClick={() => setNeedRefresh(false)}>
        Depois
      </button>
      <Button size="sm" onClick={() => void updateServiceWorker(true)}>
        Atualizar
      </Button>
    </div>
  );
}

interface InstallEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: InstallEvent | null = null;
const subscribers = new Set<() => void>();
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e as InstallEvent;
    subscribers.forEach((s) => s());
  });
}

/** Sugestão de instalação depois de um momento de valor (docs/user-flows.md F4). */
export function useInstallPrompt() {
  const [available, setAvailable] = useState(!!deferred);
  useEffect(() => {
    const s = () => setAvailable(!!deferred);
    subscribers.add(s);
    return () => {
      subscribers.delete(s);
    };
  }, []);
  const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.matchMedia('(display-mode: standalone)').matches;
  return {
    available,
    isIos,
    install: async () => {
      if (!deferred) return;
      await deferred.prompt();
      deferred = null;
      setAvailable(false);
    },
  };
}

/** Ao terminar sessão: apaga dados do utente guardados no dispositivo. */
export async function clearDeviceData(): Promise<void> {
  try {
    await caches.delete('nolens-patient-api');
  } catch {
    // Cache API indisponível
  }
}
